import { Badge, Space } from 'antd';
import { useEffect, useState } from 'react';
import { useTranslate } from '@tolgee/react';
import { nonCompletedCount } from 'views/Todo/service';

function TodoNav() {
  const { t } = useTranslate();

  const [count, setCount] = useState<number>();

  useEffect(() => {
    const handler = () => {
      nonCompletedCount()
        .then(({ num }) => {
          setCount(num);
        })
        .catch(() => {});
    };

    const timer = setInterval(handler, 15 * 1000);

    handler();

    return () => {
      clearInterval(timer);
    };
  }, []);

  return (
    <Space>
      {t('todo.待办')}
      {count !== undefined && (
        <Badge count={count} overflowCount={9999} style={{ background: '#705CF2' }} />
      )}
    </Space>
  );
}

export default TodoNav;
